import { useState } from 'react';
import { RetroSpinner } from './RetroSpinner';

export const LazyImage = ({
  src,
  alt,
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement>) => {
  const [loaded, setLoaded] = useState(false);

  const {
    onLoad: userOnLoad,
    onError: userOnError,
    style: userStyle,
    ...rest
  } = props;

  const handleLoad: React.ReactEventHandler<HTMLImageElement> = (e) => {
    setLoaded(true);
    if (typeof userOnLoad === 'function') userOnLoad(e);
  };

  const handleError: React.ReactEventHandler<HTMLImageElement> = (e) => {
    // hide spinner on error as well so UI doesn't get stuck
    setLoaded(true);
    if (typeof userOnError === 'function') userOnError(e);
  };

  const combinedStyle = {
    ...(userStyle as React.CSSProperties | undefined),
    display: loaded ? undefined : 'none',
  };

  return (
    <>
      {!loaded && <RetroSpinner />}
      <img
        src={src}
        alt={alt}
        {...rest}
        onLoad={handleLoad}
        onError={handleError}
        style={combinedStyle}
      />
    </>
  );
};
